import type { Dispatch } from "react";
import type { IAppStore } from "./ReduxHooks";
import type { UnknownAction } from "redux";

class DispatchService {
    dispatch?:Dispatch<UnknownAction> = undefined;
    getState = null;
    store:IAppStore = null;
    SetStore = (store: IAppStore) => {

        this.dispatch = store.dispatch;
        this.getState = store.getState;
        this.store = store;
    };

}

/**
 * @type {{ dispatch: Function, getState:Function, SetStore: Function, store: import('redux').Store  }}
 */
const dispatchService = new DispatchService();
export default dispatchService;